import { ImageResizer } from '../ImageResizer';
import { Analytics } from '../../services/Analytics';

import { Injectable, NgZone } from '@angular/core';
import { URLSearchParams, Jsonp } from '@angular/http';

import { BehaviorSubject, Subscription, Observable } from 'rxjs';

import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';

import { database, auth } from 'firebase';

import { BookArray } from './BookArray';
import { Shelf } from './Shelf';
import { Library } from './Library';
import { GettingStartedStages } from './GettingStartedStages'

import { Utilities } from '../Utilities'

import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import 'rxjs/add/operator/toPromise';

import swal from 'sweetalert';

import { ConfigData } from '../ConfigData'

import { BookData } from '../../components/importer/importer'

export class LoginOptions {
    scope:String;
};

@Injectable()
export class ShelvableBackend {
    loggedInUserId:BehaviorSubject<string> = new BehaviorSubject<string>(null);
    
    config:any = ConfigData.data; 

    shelvableRoot:firebase.database.Reference;

    static librarianUrl:string = '/s';

    loggedInUserShelves:Observable<Shelf[]>;

    gettingStartedStages:GettingStartedStages;

    constructor(private db:AngularFireDatabase, private shelvableAuth:AngularFireAuth, private http: HttpClient, private imageResizer:ImageResizer, private zone:NgZone) {
        var debugMode = ConfigData.data.debugMode;
        BookArray.debugMode = debugMode;
        Shelf.debugMode = debugMode;
        Library.debugMode = debugMode;
        this.debugMode = debugMode;
        
        this.shelvableRoot = db.database.ref();
        this.gettingStartedStages = new GettingStartedStages(this.loggedInUserId, this.shelvableRoot, this.db);
        
        var loggedInUserLibrary = this.loggedInUserId
            .do((userId) => console.log('getting library for ' + userId))
            .map(userId => userId ? this.getLibrary(userId) : null)
            .shareReplay(1);

        this.loggedInUserShelves = loggedInUserLibrary
            .do(() => console.log('getting shelves from library'))
            .flatMap((library) => library ? library.shelves : Observable.of(null))
            .shareReplay(1);

        this.shelvableAuth.authState.subscribe(async (user) => {
            if (user) {
                var uid = user.uid;
                var userIdRef = this.shelvableRoot.child('userIds').child(uid);

                var snapshot = await this.db.object(userIdRef, {preserveSnapshot: true}).take(1).toPromise();
                if (snapshot.exists()) {
                    NgZone.assertInAngularZone();
                    this.loggedInUserId.next(snapshot.val());
                    this.authState.initialAuthComplete = true;
                    if (debugMode) {
                        console.log('user is ' + this.config.firebaseUrl + '/users/' + snapshot.val());
                    }
                    this.updateLastLogin();
                } else {
                    try {
                        var token = await user.getIdToken();
                        var result:any = await this.http.post(ShelvableBackend.librarianUrl + '/api/generateUserId', {
                            token: token
                        }).toPromise();

                        if (result.userId) {
                            NgZone.assertInAngularZone();
                            this.loggedInUserId.next(result.userId);
                            this.authState.initialAuthComplete = true;
                            this.setUpUser();
                        } else {
                            NgZone.assertInAngularZone();
                            this.shelvableAuth.auth.signOut();
                            console.error('unable to generate userId.');
                            swal("There was a problem logging you in.", "Try logging in again.", "error");
                            this.loggedInUserId.next(null);
                        }
                    } catch (error) {
                        console.error(error);
                    }
                }
                
            } else {
                this.authState.initialAuthComplete = true;
                NgZone.assertInAngularZone();
                this.loggedInUserId.next(null);
            }
        });
    }

    debugMode:boolean;

    authState:{
        initialAuthComplete:boolean,
        isLoggingIn:boolean
    } = {
        initialAuthComplete: false,
        isLoggingIn: false
    }


    
    loginWithProvider = (provider:String, options:LoginOptions): Promise<void> => {
        var authProvider;
        if (provider === 'google') {
            authProvider = new auth.GoogleAuthProvider();
            if (options.scope) authProvider.addScope(options.scope);
        } else if (provider === 'twitter') {
            authProvider = new auth.TwitterAuthProvider();
            // TwitterAuthProvider doesn't support scopes
        } else if (provider === 'facebook') {
            authProvider = new auth.FacebookAuthProvider();
            if (options.scope) authProvider.addScope(options.scope);
        } else {
            console.error('Unknown login provider: ' + provider);
            return Promise.reject('Unknown login provider: ' + provider);
        }

        this.authState.isLoggingIn = true;
        var loginPromise;
        if (/Mobi/.test(navigator.userAgent)) {
            loginPromise = <Promise<void>> auth().signInWithRedirect(authProvider);
        } else {
            loginPromise = auth().signInWithPopup(authProvider).catch((error:any) => { //TODO: Error doesn't have .code?
                if (error.code === "TRANSPORT_UNAVAILABLE") {
                    return auth().signInWithRedirect(authProvider);
                } else {
                    return Promise.reject(error);
                }
            });
        }

        return loginPromise.then(() => {
            this.authState.isLoggingIn = false;
        }).catch((error) => {
            console.warn(error);
            return Promise.reject("Error logging in.");
        });
    }

    private shelfList = this.loggedInUserId.flatMap((userId) => {
        console.log('getting shelf list');
        var bookshelvesRef = this.shelvableRoot.child('users').child(userId).child('bookshelves');
        return this.db.object(bookshelvesRef).map(Object.keys).distinctUntilChanged(Utilities.compareArrayOfStrings);
    }).shareReplay(1);

    async validateShelfName(name:string, allowSameName:boolean):Promise<{message?:string, isValid:boolean}> {
        var shelfList = await this.shelfList.take(1).toPromise();

        var validity = '';
        if (name === '') {
            return {isValid: false, message: ''};
        } else if (name.length > 100) {
            return {isValid: false, message: 'Shelf names must be less than 100 letters long.'};
        } else if (name.length <= 1) {
            return {isValid: false, message: 'Shelf names must be more than one letter long.'};
        } else if (shelfList && shelfList.some((shelfName) => shelfName === name) && !allowSameName) {
            return {isValid: false, message: 'A shelf already exists with this name.'};
        } else if (!name.match(/^[a-zA-Z0-9\'\,\(\)\-\ ]*$/)) {
            return {isValid: false, message: 'Shelf names can only contain letters, numbers, spaces and the following: ()\'-.:'};
        } else {
            return {isValid:true}
        }
    };

    static validUsernameRegex = /^[a-zA-Z0-9\-]{2,}$/;
    static isUsernameValid = (username:string): boolean => {
        return ShelvableBackend.validUsernameRegex.test(username);
    }

    getProfilePictureUrl = (userId:string, lastUpdated:string):string => {
        if (!lastUpdated) {
            // if there's no lastUpdated field then there'll be no profile picture
            return '';
        }


        // for some reason Firebase storage expects location to be URL encoded
        return "https://firebasestorage.googleapis.com/v0/b/" + this.config.storageBucket + "/o/" + encodeURIComponent('profile-pictures/' + userId) + "?alt=media&decache=" + lastUpdated;

        // here's the SDK-way to do it but it returns a promise which is ugly with ng-src
        //var profilePicRef = shelvableStorage.ref().child('profile-pictures').child(userId);
        //return profilePicRef.getDownloadURL();
    } 
    
    
    static getEmail = (authData:firebase.User):string => {
        return authData.providerData.length > 0 ? authData.providerData[0].email : null;
    }
    
    async setUpUser():Promise<void> {
        var user = await this.shelvableAuth.authState.take(1).toPromise();

        var photoURL = user.photoURL;
        
        var defaultPhotoUrls = ['https://lh3.googleusercontent.com/-XdUIqdMkCWA/AAAAAAAAAAI/AAAAAAAAAAA/4252rscbv5M/photo.jpg'];

        //TODO is this broken?
        if (defaultPhotoUrls.indexOf(photoURL) === -1) {
            try {
                var resizedImage = await this.imageResizer.resize(photoURL);
                this.setProfilePicture(resizedImage);
            } catch (error) {
                console.error(error);
            }
        }
        
        var email = ShelvableBackend.getEmail(user);
        if (email) {
            this.setEmailAddress(email);
        }
        
    }
    
    updateLastLogin = ():void => {
        this.shelvableRoot.child('timing').child('lastLogin').child(this.loggedInUserId.getValue()).set(database.ServerValue.TIMESTAMP);
    }
    
    updateDateJoined = ():void => {
        this.shelvableRoot.child('timing').child('dateJoined').child(this.loggedInUserId.getValue()).set(database.ServerValue.TIMESTAMP);        
    }
    
    logOut = ():void => {
        NgZone.assertInAngularZone();
        this.loggedInUserId.next(null);
        if (this.debugMode) {
            console.log('loggedInUserId set to null');
        }
        
        this.shelvableAuth.auth.signOut();

        //TODO: remove this grotty workaround
        window.location.reload();
    
    }
    
    getUniqueKey = ():string => {
        return this.shelvableRoot.push().key;
    }
    
    doesShelfExist = (userId:string, shelfName:string):Observable<boolean> => {
        if (this.debugMode) {
            console.log('checking if shelf ' + userId + '/' + shelfName + ' exists');
        }
        var shelfRef;
        if (userId === this.loggedInUserId.getValue()) {
            shelfRef = this.shelvableRoot.child('users').child(userId).child('bookshelves').child(shelfName);
        } else {
            shelfRef = this.shelvableRoot.child('users').child(userId).child('publicShelves').child(shelfName);
        }
        return this.db.object(shelfRef).map((shelf) => shelf.$exists());
    }

    async getLoggedInUserShelf(shelfName:string):Promise<Shelf> {
        if (this.authState.initialAuthComplete && !this.loggedInUserId.getValue()) {
            throw "User not logged in";
        } else {
            var loggedInUserId:string = await this.loggedInUserId.filter(Utilities.isNotNull).take(1).toPromise();
            return new Shelf(loggedInUserId, shelfName, this.shelvableRoot, this.loggedInUserId, this.db, this.zone);
        }
    }
    
    getShelf(userId:string, shelfName:string):Shelf {
        return new Shelf(userId, shelfName, this.shelvableRoot, this.loggedInUserId, this.db, this.zone);
    }
  
    getLibrary = (userId:string):Library => {
        if (!userId && !this.loggedInUserId.getValue()) {
            throw "No userId specified for getLibrary";
        } else {
            return new Library(userId, this.loggedInUserId, this.shelvableRoot, this.db, this.zone);
        }
    }
    
    private async getMaxPriority(ref:firebase.database.Reference):Promise<string | number> {
        var snap = await this.db.list(ref, {preserveSnapshot: true, query: {orderByPriority: true, limitToLast: 1}}).take(1).toPromise();

        if (snap.length > 0) {
            return snap[0].getPriority();
        } else {
            return 0;
        }
    };
    
    async addShelf(name):Promise<void> {
        Analytics.createShelf();

        if (!name) {
            return;
        }
        
        var bookshelvesRef = this.shelvableRoot.child('users').child(this.loggedInUserId.getValue()).child('bookshelves');
        var maxPriority = await this.getMaxPriority(bookshelvesRef);
        bookshelvesRef.child(name).setWithPriority({exists: true}, Number(maxPriority) + 1);
    };
    
    
    async getUserId(username:string):Promise<string> {
        if (!ShelvableBackend.isUsernameValid(username)) {
            return null;
        }
        var requestRef = this.shelvableRoot.child('usernames').child('request').child(username.toLowerCase());
        var requestSnapshot = await this.db.object(requestRef).take(1).toPromise();

        if (!requestSnapshot.$exists()) {
            return null;
        } else {
            var allegedUserId = requestSnapshot.$value;
            var confirmRef = this.shelvableRoot.child('usernames').child('confirm').child(allegedUserId);
            var confirmSnapshot = await this.db.object(confirmRef).take(1).toPromise()
            
            var confirmedUsername = confirmSnapshot.$value;
            if (confirmSnapshot.$exists() && confirmedUsername.toLowerCase() === username.toLowerCase()) {
                return allegedUserId;
            } else {
                return null;
            }
        }
    
    };

    loggedInUserData:Observable<any> = this.loggedInUserId.filter(Utilities.isNotNull).flatMap((userId) => this.getUserData(userId));

    getUserData = (userId:string):FirebaseObjectObservable<any> => {
        var userDataRef = this.shelvableRoot.child('users').child(userId).child('userData');
        
        return this.db.object(userDataRef);
    }
    
    updateUserData(newData):Promise<any> {
        var userRef = this.shelvableRoot.child('users').child(this.loggedInUserId.getValue()).child('userData');
        return <Promise<any>> this.db.object(userRef).update(newData);
    }

    emailDetails = this.loggedInUserId.filter(Utilities.isNotNull).flatMap((userId) => this.db.object(this.shelvableRoot.child('email').child('addresses').child(userId)))

    async setEmailAddress(address):Promise<void> {
        var addressRef = this.shelvableRoot.child('email').child('addresses').child(this.loggedInUserId.getValue());
        await addressRef.update({address: address, isConfirmed: false});
        this.sendConfirmEmail();
    }
    
    resubscribe = ():void => {
        this.shelvableRoot.child('email').child('addresses').child(this.loggedInUserId.getValue()).child('isUnsubscribed').set(false);
    }

    async sendConfirmEmail():Promise<void> {
        try {
            var user = await this.shelvableAuth.idToken.take(1).toPromise();
            var token = await user.getIdToken();
            await this.http.post(ShelvableBackend.librarianUrl + '/email/sendConfirmation', '', {
                params: new HttpParams().set('auth', token)
            }).toPromise();
            console.log('Confirm email sent.')
        } catch (err) {
            console.error(err);
        }
    }
    
    checkUserExists(username:string):Observable<boolean> {
        var resultSubj = new BehaviorSubject<boolean>(null);
        (async () => {
            var requestRef = this.shelvableRoot.child('usernames').child('request').child(username.toLowerCase());
            var requestSnapshot = await this.db.object(requestRef).take(1).toPromise();
                
            if (!requestSnapshot || !requestSnapshot.$exists()) {
                return false;
            } else {
                var userId = requestSnapshot.$value;
                var confirmRef = this.shelvableRoot.child('usernames').child('confirm').child(userId);
                var confirmSnapshot = await this.db.object(confirmRef).take(1).toPromise();
                return confirmSnapshot.$exists() && confirmSnapshot.$value.toLowerCase() === username.toLowerCase();
            }
        })().then((result) => { resultSubj.next(result); resultSubj.complete() });
        return resultSubj.asObservable();
    };

    
    isUsernameReserved = (username:string): Observable<boolean> => {
        var resultSubj = new BehaviorSubject<boolean>(null);

        (async () => {
            if (username === null) {
                return false;
            }
            var requestRef = this.shelvableRoot.child('usernames').child('reserved').child(username.toLowerCase());
            var requestSnapshot = await this.db.object(requestRef).take(1).toPromise();
                
            return requestSnapshot.$exists();
        })().then((result) => { resultSubj.next(result); resultSubj.complete() });
        return resultSubj.asObservable();
    }

    
    async claimUsername(username):Promise<void> {
        try {
            await this.shelvableRoot.child("usernames").child("request").child(username.toLowerCase()).set(this.loggedInUserId.getValue());
            await this.shelvableRoot.child("usernames").child("confirm").child(this.loggedInUserId.getValue()).set(username);
        } catch (err) {
            console.error(err);
        }
    }
    
    async setProfilePicture(src:string):Promise<void> {
        try {
            var user = await this.shelvableAuth.authState.take(1).toPromise();
            var token = await user.getIdToken();
            
            // this is the SDK-way to do this, but we can't use it because we need to key on userId, 
            // and Storage rules can't access the Database to get it.
            //var setBlobPromise = shelvableStorage.ref().child('profile-pictures').child(loggedInUserId).putString(src, 'data_url');
            
    
            await this.http.put(ShelvableBackend.librarianUrl + '/api/setProfilePicture', src, {
                params: new HttpParams().set('auth', token),
                headers: new HttpHeaders().set('Content-Type', 'text/plain')
            }).toPromise();
    
            await this.shelvableRoot
                .child('users')
                .child(this.loggedInUserId.getValue())
                .child('userData')
                .child('profilePictureLastChanged').set(database.ServerValue.TIMESTAMP);
        } catch (err) {
            console.error(err);
        }
    }
    
    async setShelfPrivacy(shelfName:string, isPublic:boolean):Promise<void> {

        var privacyRef = this.shelvableRoot.child('users').child(this.loggedInUserId.getValue()).child('publicShelves').child(shelfName);
        var shelfExists = await this.doesShelfExist(this.loggedInUserId.getValue(), shelfName).take(1).toPromise();

        if (isPublic !== null && shelfExists) {
            var privacyObj = this.db.object(privacyRef);
            if (isPublic) {
                await privacyObj.set(true);
            } else {
                await privacyObj.remove();
            }
        }
    }
    
    async deleteShelf(shelfName:string):Promise<void> {
        var userRef = this.shelvableRoot.child('users').child(this.loggedInUserId.getValue());
        await Promise.all([
            userRef.child('bookshelves').child(shelfName).remove(),
            userRef.child('publicShelves').child(shelfName).remove()
        ]);
    }
    
    async renameShelf(oldName:string, newName:string):Promise<void> {
        var userRef = this.shelvableRoot.child('users').child(this.loggedInUserId.getValue());
        
        var newShelfObj = this.db.object(userRef.child("bookshelves").child(newName));
        var oldShelfObj = this.db.object(userRef.child("bookshelves").child(oldName), {preserveSnapshot: true});
        
        var newPrivacyObj = this.db.object(userRef.child("publicShelves").child(newName));
        var oldPrivacyObj = this.db.object(userRef.child("publicShelves").child(oldName));
        
        var shelfData = (await oldShelfObj.take(1).toPromise()).exportVal();
        
        await newShelfObj.set(shelfData)
        await newPrivacyObj.set((await oldPrivacyObj.take(1).toPromise()).$value),
        await oldPrivacyObj.remove()
        await oldShelfObj.remove();
    }

    async importShelves(shelves:{[shelfName:string]:BookData[]}):Promise<void> {
        var updates = {};
        var shelvesRef = this.shelvableRoot.child('users').child(this.loggedInUserId.getValue()).child("bookshelves");

        var promises = [];
        for (var shelfName in shelves) {
            updates[shelfName + '/exists'] = true;
            
            var books = shelves[shelfName];
            for (var i = 0; i < books.length; i++) {
                promises.push((async function(shelfName) {
                    try {
                        var googleId = await books[i].promise;
                        if (googleId) {
                            var key = shelvesRef.push().key ;
                            updates[shelfName + '/books/' + key] = {
                                googleId: googleId,
                                '.priority': i
                            };
                        } else {
                            console.log('No google ID found for this book, skipping')
                            console.log(books[i]);
                        }
                    } catch(err) {
                        console.error(err);
                    }
                })(shelfName))
            }
            
        }
        
        await Promise.all(promises)
        await shelvesRef.update(updates);
    }

    
    private confirmObjObs = this.loggedInUserId.flatMap((userId) => {
        if (userId === null) {
            return Observable.of(null);
        } else {
            var confirmRef = this.shelvableRoot.child('usernames').child('confirm').child(userId);
            return this.db.object(confirmRef);
        }
    });
    
    loggedInUserObs:{
        isLoggedIn:Observable<boolean>
        usernameObs:Observable<string>
        isRegisteredObs:Observable<boolean>
        profilePicUrlObs:Observable<string>
        providerObs:Observable<string>
    } = {
        isLoggedIn: this.loggedInUserId.map((userId) => userId != null).shareReplay(1),
        usernameObs: this.confirmObjObs.map((confirmObj) => confirmObj && confirmObj.$exists() ? <string> confirmObj.$value : null).shareReplay(1),
        isRegisteredObs: this.confirmObjObs.map((confirmObj) => !!confirmObj && (<boolean> confirmObj.$exists())).shareReplay(1),
    
        profilePicUrlObs: this.loggedInUserId.flatMap((userId) => {
            if (userId === null) {
                return Observable.of(null);
            } else {
                var profilePictureLastChangedRef = this.shelvableRoot.child('users').child(userId).child('userData').child('profilePictureLastChanged');
                return this.db.object(profilePictureLastChangedRef).map((profilePictureLastChanged) => this.getProfilePictureUrl(userId, profilePictureLastChanged.$value));
            }
        }).shareReplay(1),
    
        providerObs: this.shelvableAuth.authState.map((user) => user.providerData.length > 0 ? user.providerData[0].providerId : null).shareReplay(1)
    }
    
    getExploreByKeywordFactory(authorsOrSubjects:string):(keyword:string) => Promise<any> {
        return async (keyword:string) => {
            var exploreRef = this.shelvableRoot.child('explore').child(authorsOrSubjects);
            var value:{$key:string, [key:string]:string}[] = await this.db.list(exploreRef, {query: {orderByChild: 'keyword', equalTo: keyword.toLowerCase()}}).take(1).toPromise();
            if (value.length > 0) {
                var val = value[0];
                val.url = val.$key;
                return val;
            } else {
                throw 'Keyword not found';
            }
        }
    }
    
    getExploreByQueryFactory = (authorsOrSubjects:string):(query:string) => Promise<any> => {
        return async (query:string) => {
            var queryRef = this.shelvableRoot.child('explore').child(authorsOrSubjects).child(query);
            var value = await this.db.object(queryRef).take(1).toPromise()
            if (value.$exists()) {
                value.url = value.$key;
                return value;
            } else {
                throw "Author or subject not found";
            }
        }
    } 
    
    getExploreAuthorByQuery = this.getExploreByQueryFactory('authors');
    getExploreSubjectByQuery = this.getExploreByQueryFactory('subjects');
    getExploreAuthorByKeyword = this.getExploreByKeywordFactory('authors');
    getExploreSubjectByKeyword = this.getExploreByKeywordFactory('subject');
    
    getAuthors = (firstChars:string):Observable<{ url:string, name:string }[]> => {
        var ref = this.shelvableRoot.child('explore').child('authors');
        return this.db.list(ref, {
            query: {
                orderByChild: 'lowerCaseName',
                startAt: firstChars.toLowerCase(),
                limitToFirst: 10
            }
        }).map((value:{$key:string, [key:string]:string}[], index) => {
            return value.map((author) => {return { url: author.$key, name: author.name } });
        });
    };
    

};



// WEBPACK FOOTER //
// ./web/static/services/ShelvableBackend/ShelvableBackend.ts